import type { ReactNode } from 'react';

import { Icon, type IconName } from '@/components/ui/icon';
import { cn } from '@/lib/cn';

export interface EmptyStateProps {
  icon?: IconName;
  title: string;
  description?: string;
  /** Primary call to action, e.g. "Add the first document". */
  action?: ReactNode;
  className?: string;
}

export function EmptyState({
  icon = 'documents',
  title,
  description,
  action,
  className,
}: EmptyStateProps) {
  return (
    <div
      className={cn('flex flex-col items-center justify-center px-6 py-10 text-center', className)}
    >
      <div className="mb-3 flex h-10 w-10 items-center justify-center rounded-md border border-border bg-surface-muted text-content-subtle">
        <Icon name={icon} size={18} />
      </div>
      <p className="text-sm font-medium text-content">{title}</p>
      {description && <p className="mt-1 max-w-sm text-xs text-content-muted">{description}</p>}
      {action && <div className="mt-4">{action}</div>}
    </div>
  );
}
